import axios from 'axios';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { ButtonGroup, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SlidingPane from "react-sliding-pane";
import { signOut } from '../../../../actions/auth.actions';
import Button from '../../../../shared/components/Button';
import Select from '../../../../shared/components/Select';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const DeactivateSidePane = ({ isPaneOpen, onRequestClose, signOut }) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const deactivationReasons = [
    'not_creating_content_anymore',
    'too_many_emails',
    'complex_campaigns',
    'data_erasure',
    'other',
  ];

  const formik = useFormik({
    initialValues: {
      reason: 'not_creating_content_anymore'
    },
    onSubmit: values => {
      setLoading(true);
      axios.put(`/api/v1/influencers/users`, {
        user: { deactivation_reason: values.reason, deactivated: true }
      }).then(() => {
        setLoading(false);
        signOut();
      }).catch((e) => {
        setLoading(false);
        console.log(e);
      });
    }
  });

  return (
    <div>
      <SlidingPane
        hideHeader
        isOpen={isPaneOpen}
        width={breakpoint !== 'xs' ? '375px' : '100%'}
        shouldCloseOnEsc
        onRequestClose={onRequestClose}
        from={document.body.dir === 'ltr' ? 'right' : 'left'}
      >
        <Form onSubmit={formik.handleSubmit}>
          <h3 className="mb-3">
            {t('influencers.pages.campaign.deactivate_side_pane.title')}
          </h3>

          <p>{t('influencers.pages.campaign.deactivate_side_pane.description')}</p>

          <Form.Group>
            <Form.Label>
              {t('influencers.pages.campaign.deactivate_side_pane.reason')}
            </Form.Label>
            <Select
              className="mb-2"
              name="reason"
              value={formik.values.reason}
              error={formik.touched.reason && formik.errors.reason}
              onChange={formik.handleChange}
              disabled={loading}
              options={deactivationReasons.map(reason => ({
                label: t(`influencers.pages.campaign.deactivate_side_pane.${reason}`),
                value: reason
              }))}
            />
          </Form.Group>

          <div className="my-6"><hr /></div>

          <Row className='justify-content-end'>
            <Col className="col-auto">
              <ButtonGroup className="non-adaptable">
                <Button
                  variant="secondary"
                  type="button"
                  onClick={() => onRequestClose()}
                  disabled={loading}>
                  {t('influencers.common.cancel')}
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  data-cy="deactivate_submit_button"
                  disabled={loading}
                >
                  {loading ?
                    <Spinner animation="border" size="sm" /> :
                    t('influencers.common.deactivate')
                  }
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Form>
      </SlidingPane>
    </div>
  );
};

DeactivateSidePane.propTypes = {
  isPaneOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
};

DeactivateSidePane.defaultProps = {
  isPaneOpen: false,
};

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = (dispatch) => ({
  signOut: () => signOut(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeactivateSidePane);
